<div class="terms-and-conditions">
    <div class="row">
        <a>< Return to Loan Details</a>
    </div>
    <div style="align-self: center;" class="row">
        <h1>Let's start your loan application!</h1>
    </div>
    <div class="terms-and-conditions-checklist">
        
        <div class="row">
            <h3>Terms and Agreements</h3>
            <p>The following consents are required to complete your loan.</p>
        </div>
        <div class="Vert-15"></div>
        <form [formGroup]="termsForm">
            <div class="row" *ngFor="let term of (loanAppTerms$ | async); let i=index">
                <div class="col-12">
                    <mat-checkbox [formControlName]="term?.key">{{term?.label}}</mat-checkbox>
                    <br>
                    <a style="margin-left: 32px;" (click)="openViewTermsModal(i)">View Terms</a>
                    <div class="Vert-15"></div>
                </div>
            </div>
        </form>
        <div class="Vert-30"></div>
        <button class="btn btn-primary" [disabled]="!termsForm.valid" (click)="navigateToStartLoanApp()">Get Started</button>
    </div>
</div>
